<template>
    <BaseSection
        v-if="isVisible"
        class="event-details"
    >
        <table>
            <tbody>
                <tr
                    v-for="(field, index) in resolvedFields"
                    :key="index"
                >
                    <th class="event-details__label">
                        <span>{{ field.label }}</span>
                    </th>
                    <td
                        class="event-details__value"
                        width="100%"
                    >
                        <span>{{ field.value }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </BaseSection>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true,
            default: null
        }
    },

    data() {
        return {
            dateFields: [
                'registrationDateRange'
            ],
            fields: {
                organiser: 'Organiser',
                cmeAccreditation: 'CME',
                membersOnly: 'Membership',
                duration: 'Duration',
                venue: 'Venue',
                address: 'Address',
                city: 'Location',
                registrationDateRange: 'Registration open',
            }
        };
    },

    computed: {
        isVisible() {
            // Edge case; dont show just duration
            return this.resolvedFields.length && !(this.resolvedFields.length === 1 && this.event.duration?.length);
        },

        // Resolve the list of fields (key => label) with the event passed to this component
        resolvedFields() {
            const resolved = [];
            Object.keys(this.fields).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(this.event, key) && this.event[key] && (this.event[key].length || this.event[key].start || typeof (this.event[key]) === 'boolean')) {
                    const value = this.processFieldValue(this.event[key], key);
                    if (value) {
                        resolved.push({
                            label: this.fields[key],
                            value
                        });
                    }
                }
            });

            return resolved;
        }
    },

    methods: {
        // Optionally process the field value
        processFieldValue(value, name) {
            if (this.dateFields.includes(name)) {
                return useDate().formatDateRange(value.start, value.end);
            }
            if (name === 'address' && this.event.city && this.event.country) {
                return `${value}, ${this.event.city}, ${this.event.country}`;
            } else if (name === 'address' && this.event.city) {
                return `${value}, ${this.event.city}`;
            }
            if (name === 'city' && this.event.address) {
                return null;
            } else if (name === 'city' && this.event.country) {
                return `${value}, ${this.event.country}`;
            }
            if (name === 'membersOnly') {
                return 'Required';
            }
            return value;
        }
    }
};
</script>

<style lang="less" src="./BaseEventDetails.less" />
